import React from 'react'
import PropTypes from 'prop-types'

const TextLink = ({ onClick, text, isNotClickable, textClass }) => {
  const elementClass = () => {
    const clickableClass = isNotClickable ? 'message-not-clickable' : 'message-clickable'

    if (textClass) return clickableClass.concat(' ').concat(textClass)
    return clickableClass
  }

  return (
  <span
    className={elementClass()}
    onClick={onClick}
  >
    {text}
  </span>
)}

TextLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  textClass: PropTypes.string.isRequired,
  isNotClickable: PropTypes.bool,
}

export default TextLink
